import { render, staticRenderFns } from "./BuddhistSatisfaction.vue?vue&type=template&id=02648476&scoped=true"
import script from "./BuddhistSatisfaction.vue?vue&type=script&lang=js"
export * from "./BuddhistSatisfaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02648476",
  null
  
)

export default component.exports